import type { InviteEntryPoint, InviteNavigationState } from '../RenterInvite.types';

export type OpenInviteSource = 'side_menu';

const DIRECT_LINK_ENTRY_POINT: InviteEntryPoint = 'direct_link';

export const resolveInviteEntryPoint = (
  isOnAppTracker: boolean,
  source?: OpenInviteSource,
): InviteEntryPoint => {
  if (source === 'side_menu') return DIRECT_LINK_ENTRY_POINT;
  if (isOnAppTracker) return 'app_tracker';
  return 'll_portal_homepage';
};

export const resolveInviteFromUrl = (): string | undefined =>
  typeof window === 'undefined' ? undefined : window.location.href;

export const buildInviteNavigationState = (
  inviteEntryPoint: InviteEntryPoint,
  source?: OpenInviteSource,
): InviteNavigationState => {
  if (source !== 'side_menu') return { inviteEntryPoint };

  const fromUrl = resolveInviteFromUrl();
  return {
    inviteEntryPoint,
    ...(fromUrl ? { fromUrl } : {}),
  };
};

const readInviteNavigationState = (locationState: unknown): InviteNavigationState => {
  if (!locationState || typeof locationState !== 'object') return {};
  return locationState as InviteNavigationState;
};

export const resolveInvitePageEntryPoint = (locationState: unknown): InviteEntryPoint =>
  readInviteNavigationState(locationState).inviteEntryPoint ?? DIRECT_LINK_ENTRY_POINT;

export const resolveInvitePageFromUrl = (locationState: unknown): string | undefined =>
  readInviteNavigationState(locationState).fromUrl;

// Only emit `from_url` for the direct_link entry point, where it's actionable for analytics.
export const shouldEmitFromUrl = (
  entryPoint: InviteEntryPoint | null | undefined,
  fromUrl: string | null | undefined,
): fromUrl is string => entryPoint === DIRECT_LINK_ENTRY_POINT && Boolean(fromUrl);
